
const messages = {
  en: {
    recargo: {
      title: 'Recargo management',
      subtitle: 'View, search, create, edit and delete Recargo',
      creating: 'Creating Recargo',
      editing: 'Editing Recargo',
      deleting: 'Deleting Recargo',
      showing: 'Showing Recargo',
      menuTitle: 'Recargos',
      manualOption: 'Manual value',
      labels: {
        nombre: 'name',
        recargo: 'charge',
        deposito: 'depot'
      },
    },
  },
  es: {
    recargo: {
      title: 'Administración de Recargo',
      subtitle: 'Ver, buscar, crear, editar, y borrar Recargo',
      creating: 'Creando Recargo',
      editing: 'Modificando Recargo',
      deleting: 'Eliminando Recargo',
      showing: 'Detalles de Recargo',
      menuTitle: 'Recargos',
      manualOption: 'Valor manual',
      labels: {
        nombre: 'nombre',
        recargo: 'recargo',
        deposito: 'depósito'
      },
    },
  },
  pt: {
    recargo: {
      title: 'Administração de Recargo',
      subtitle: 'Ver, buscar, criar, editar e usar Recargo',
      creating: 'Criando Recargo',
      editing: 'Edição Recargo',
      deleting: 'Apagando Recargo',
      showing: 'Detalhes do Recargo',
      menuTitle: 'Recargos',
      manualOption: 'Valor manual',
      labels: {
        nombre: 'nome',
        recargo: 'sobretaxa',
        deposito: 'depósito'
      },
    },
  }
}

export default messages
